import { useSelector } from "react-redux";
import { selectDomainConfigByDomainName } from "../store/slices/whitelabelling/selectors";

export default function useCurrentDomainConfig() {
  const domain = window.location.hostname;
  const domainConfig = useSelector(selectDomainConfigByDomainName(domain));
  return domainConfig;
}
